import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import ReactDOM from 'react-dom';
import { Popover } from 'react-bootstrap';
import keymaster from 'keymaster';
import moment from 'moment';
import time from '../utils/time';

import AutoTaskInput from './AutoTaskInput';
import DurationFormatter from '../utils/duration';
import SimpleHashtagEditor from './SimpleHashtagEditor';

import * as logEntryActions from '../actions/logEntryActionCreators';

require.ensure([], () => {
    require('./EditPopover.less');
});

const className = "EditPopover";

class EditPopover extends React.Component {

    constructor(props, context) {
        super(props, context);

        let positionLeft = this.props.positionLeft;
        let placement = "right";
        let hm = time.parseDuration(this.props.logEntry.duration + "min");

        let logEntries = JSON.parse(JSON.stringify(this.props.logEntries));
        for (let i = 0; i < logEntries.length; i++) {
            if (logEntries[i].id === this.props.logEntry.id) {
                logEntries.splice(i, 1);
                break;
            }
        }

        this.taskInput = {};

        this.state = {
            errors: [],
            cumulativeMap: this._buildCumulativeObject(logEntries),
            initialDuration: this.props.logEntry.duration,
            duration: hm !== null ? hm[2] : 0,
            durationString: hm !== null ? time.durationFormat(hm[0], hm[1]) : "",
            startTime: this.props.logEntry.startTime,
            description: this.props.logEntry.description,
            overtime: this.props.logEntry.overtime,
            lastModifiedByUser: this.props.logEntry.lastModifiedByUser,
            lastModifiedAt: this.props.logEntry.lastModifiedAt,
            editForUser: this.props.editForUser,
            date: this.props.logEntry.date ? moment(this.props.logEntry.date, "YYYY-MM-DD"): null,
            color: this.props.logEntry.color,
            positionLeft: positionLeft,
            positionTop: (this.props.positionTop < 0) ? 0 : this.props.positionTop,
            placement: placement,
            parent: this.props.parent,
            smartPopoverPlacement: this.props.smartPopoverPlacement,
            pmoMode: this.props.pmoMode,
            elementFocused: true,
            footerFocused: false,
            editTask: false,
            tasks: this.props.tasks,
            projectName: this.props.logEntry.projectName,
            selectedTask: this.props.selectedTask,
            taskName: this.props.logEntry.taskName
        };
    }

    // LIFECYCLE METHODS

    componentDidMount = () => {
        this.setState({
            selfWidth: ReactDOM.findDOMNode(this).offsetWidth
        });
        keymaster.unbind('left');
        keymaster.unbind('right');
    }

    componentWillReceiveProps = (nextProps) => {
        let positionLeft = nextProps.positionLeft;
        let placement = "right";

        if(nextProps.selectedTask) {
            this.setState({selectedTask: nextProps.selectedTask});
        }

        if (this.state.smartPopoverPlacement && window.innerWidth > 640) {
            if (positionLeft + 300 > window.innerWidth) {
                placement = "left";
                positionLeft -= this.state.selfWidth + ReactDOM.findDOMNode(nextProps.parent).offsetWidth;

                // what happens is that on the first showing of the popover we get a parent offsetWidth
                // but on the second render we mysteriously always get 45 pixels larger parent offsetWidth
                // so on the first call, when this state.positionLeft has not been set yet, we do the math
                // but on each other call we subtract additional 45 pixels
                // this hardcoded version works best but lets try to solve it programatically
                //if (this.state.selfWidth === 300) {
                //    positionLeft -= 45;
                //}
                if (this.state.positionLeft) {
                    positionLeft -= 45;
                }
            }
        }

        let hm = time.parseDuration(nextProps.logEntry.duration + "min");

        let startTime = nextProps.logEntry.startTime;

        if (startTime && startTime.length === 12 && startTime.charAt(2) === ':' && startTime.charAt(5) === ':' && startTime.charAt(8) === '.') {
            startTime = startTime.substring(0, 5);
        }

        if (startTime && startTime.length === 8 && startTime.charAt(2) === ':' && startTime.charAt(5) === ':') {
            startTime = startTime.substring(0, 5);
        }

        let logEntries = JSON.parse(JSON.stringify(nextProps.logEntries));
        for (let i = 0; i < logEntries.length; i++) {
            if (logEntries[i].id === nextProps.logEntry.id) {
                logEntries.splice(i, 1);
                break;
            }
        }

        this.setState({
            errors: [],
            cumulativeMap: this._buildCumulativeObject(logEntries),
            initialDuration: nextProps.logEntry.duration,
            duration: hm !== null ? hm[2] : 0,
            durationString: hm !== null ? time.durationFormat(hm[0], hm[1]) : "",
            startTime: startTime,
            description: nextProps.logEntry.description,
            overtime: nextProps.logEntry.overtime,
            lastModifiedByUser: nextProps.logEntry.lastModifiedByUser,
            lastModifiedAt: nextProps.logEntry.lastModifiedAt,
            editForUser: nextProps.editForUser,
            date: nextProps.logEntry.date ? moment(nextProps.logEntry.date, "YYYY-MM-DD"): null,
            positionLeft: positionLeft,
            positionTop: (nextProps.positionTop < 0) ? 0 : nextProps.positionTop,
            placement: placement,
            parent: nextProps.parent,
            smartPopoverPlacement: nextProps.smartPopoverPlacement,
            pmoMode: nextProps.pmoMode,
            tasks: nextProps.tasks,
            projectName: nextProps.logEntry.projectName,
            taskName: nextProps.logEntry.taskName
        });
    }

    componentWillUnmount = () => {
        if (this.props.returnKeymaster) {
            this.props.returnKeymaster();
        }
    }

    // EVENT HANDLERS

    handleDescriptionChange = (description) => {
        this.setState({
            description: description
        });
    }

    handleCancel = () => {
        this.props.close();
    }

    handleChange = (changeEvent) => {
        this.setState({
            overtime: !this.state.overtime
        });
    }

    handleCumulativeToggle = () => {
        this.setState({
            showCumulative: !this.state.showCumulative
        });
    }

    handleDelete = () => {
        this.props.close();

        if (this.props.timesheet && !this.props.logEntry.overtime) {
            this.props.timesheet.timeSpent -= this.state.initialDuration;
        }
        if (this.props.pmoMode) {
            this.props.dispatch(logEntryActions.pmoDeleteEntry(this.props.logEntry.id));
        } else {
            this.props.dispatch(logEntryActions.deleteEntry(this.props.logEntry.id));
        }
    }

    handleDurationChange = (event) => {
        this.setState({
            durationString: event.target.value
        });
    }

    handleEditTaskButton = () => {
        this.setState({
            editTask: !this.state.editTask
        }, () => {
            if (this.state.editTask) {
                //ReactDOM.findDOMNode(this.refs.taskInput.refs.taskField).focus();
            }
        });
    }

    handleElementBlur = () => {
        this.setState({
            elementFocused: false
        });
    }

    handleElementFocus = () => {
        this.setState({
            elementFocused: true
        });
    }

    handleFooterBlur = () => {
        this.setState({
            footerFocused: false
        });
    }

    handleFooterFocus = () => {
        this.setState({
            footerFocused: true
        });
    }

    handleKeyPress = (keyEvent) => {
        if (keyEvent.key === "Enter" && !keyEvent.shiftKey && !this.state.footerFocused && !this.state.editTask) {
            if (this.state.pmoMode || (!this.props.timesheet || this.props.timesheet && this.props.timesheet.status === "ENTRY")) {
                keyEvent.preventDefault();
                ReactDOM.findDOMNode(this.refs.durationInput).blur();
                setTimeout(this.handleSave, 50);
            }
        }
    }

    handleKeyUp = (keyEvent) => {
        if (keyEvent.key === "Escape") {
            this.handleCancel();
        }

        keyEvent.stopPropagation();
    }

    handleRefocus = (event) => {
        ReactDOM.findDOMNode(this.refs.durationInput).focus();
        this.setState({
            footerFocused: false
        });
    }

    handleSave = () => {
        let logEntry = {};

        // TODO: sanitize input
        logEntry.date = this.state.date.format("YYYY-MM-DD");
        let duration = this.state.duration;
        let startTime = this.state.startTime;
        let description = this.state.description;
        let overtime = this.state.overtime;

        let errors = [];

        if (isNaN(duration))
            duration = 0;

        if (duration > 1200) {
            errors.push({ input: "duration", message: "Duration cannot exceed 20 hours" });
        }

        if (duration < 0) {
            errors.push({ input: "duration", message: "Duration cannot be negative" });
        }

        if (startTime && startTime.length > 0) {
            let startTimeValidation = new RegExp(/^([0-9]?|1[0-9]|2[0-3]|0[0-9]):[0-5][0-9]$/);

            if (!startTimeValidation.test(startTime)) {
                errors.push({ input: "startTime", message: "Start time must be in HH:mm format" });
            }
        }

        if (errors.length > 0) {
            this.setState({
                errors: errors
            });

            return;
        }

        logEntry.duration = duration;
        logEntry.startTime = startTime;
        logEntry.description = description;
        logEntry.overtime = overtime;
        logEntry.lastModifiedByUser = "user unknown (user)";
        logEntry.lastModifiedAt = moment().format("YYYY-MM-DD[T]H:mm:ss");

        // format start time as HH:mm or HH:mm:ss
        if (logEntry.startTime && logEntry.startTime.charAt(1) === ":") {
            logEntry.startTime = "0" + logEntry.startTime;
        }

        if (this.props.currentUser) {
            logEntry.lastModifiedByUser = this.props.currentUser.givenName + " " + this.props.currentUser.surname + " (" + this.props.currentUser.username + ")";
        }

        if (this.props.pmoMode) {
            logEntry.userID = this.props.editForUser.id;
            logEntry.status = "ACCEPTED";
        }

        logEntry.taskID = this.props.logEntry.taskID;

        logEntry = Object.assign({}, this.props.logEntry, logEntry);

        if (this.state.taskChanged) {
            logEntry.color = this.state.color;
            logEntry.taskName = this.state.selectedTask.name;
            logEntry.projectName = this.state.selectedTask.projectName;
            logEntry.task = {};
            logEntry.task.id = this.state.selectedTask.id;

            if (this.props.pmoMode) {
                this.props.dispatch(logEntryActions.pmoUpdateWithTask(logEntry));
            } else {
                this.props.dispatch(logEntryActions.updateWithTask(logEntry));
            }
        } else if (this.props.pmoMode) {
            this.props.dispatch(logEntryActions.pmoUpdate(logEntry));
        } else {
            this.props.dispatch(logEntryActions.update(logEntry));
        }
        this.props.close();
    }

    handleSliderChange = (event) => {
        let hm = time.parseDuration(event.target.value.trim() + "min");

        this.setState({
            duration: hm !== null ? hm[2] : 0,
            durationString: hm !== null ? time.durationFormat(hm[0], hm[1]) : ""
        });
    }

    handleStartTimeChange = (event) => {
        this.setState({
            startTime: event.target.value
        }, time.checkForm.bind(this, className));
    }

    handleTaskChange = () => {
        setTimeout(() => {
            this.setState({
                color: this.props.selectedTask.color,
                taskChanged: true,
                editTask: false
            });
        }, 1);
    }

    // OTHER METHODS

    _convertToStandardForm = (event) => {
        let hm = time.parseDuration(event.target.value.trim());

        this.setState({
            duration: hm !== null ? hm[2] : 0,
            durationString: hm !== null ? time.durationFormat(hm[0], hm[1]) : "",
            elementFocused: false
        });
    }

    _convertStartTime = (event) => {
        let hm = time.parseStartTime(event.target.value.trim());

        this.setState({
            startTime: hm !== null ? time.startTimeFormat(hm[0], hm[1]) : ""
        }, this.checkForm);
    }

    _buildCumulativeObject = (logEntries) => {
        let cumulativeMap = [];

        for (let i = 0; i < logEntries.length; i++) {
            let projectName = logEntries[i].projectName ? logEntries[i].projectName : "Floating tasks";
            let taskName = logEntries[i].taskName;

            if (!cumulativeMap[projectName]) {
                cumulativeMap[projectName] = {
                    tasks: [],
                    regularTimeLogged: 0,
                    overtimeLogged: 0
                };
            }

            if (!cumulativeMap[projectName].tasks[taskName]) {
                cumulativeMap[projectName].tasks[taskName] = {
                    regularTimeLogged: 0,
                    overtimeLogged: 0
                };
            }

            if (!logEntries[i].overtime) {
                cumulativeMap[projectName].regularTimeLogged += logEntries[i].duration;
                cumulativeMap[projectName].tasks[taskName].regularTimeLogged += logEntries[i].duration;
            } else {
                cumulativeMap[projectName].overtimeLogged += logEntries[i].duration;
                cumulativeMap[projectName].tasks[taskName].overtimeLogged += logEntries[i].duration;
            }
        }

        return cumulativeMap;
    }

    _fieldHasError = (fieldName) => {
        if (!this.state.errors) {
            return false;
        }

        for (let i = 0; i < this.state.errors.length; i++) {
            if (this.state.errors[i].input === fieldName) {
                return true;
            }
        }

        return false;
    }

    // RENDER METHOD

    render = () => {
        let backgroundColor = "#777777";
        if (this.state.color) {
            backgroundColor = this.state.color;
        }

        // format lastModifiedAt nicely
        let lastModifiedAt = "unknown";

        if (this.state.lastModifiedAt) {
            let lastModifiedAtTokens = this.state.lastModifiedAt.split("T");
            lastModifiedAt = lastModifiedAtTokens[1].substring(0, 8) + " on " + lastModifiedAtTokens[0];
        }

        let calendarClass = moment().format("DD-MM-YYYY") === this.state.date.format("DD-MM-YYYY") ? "label-day today" : "label-day";

        let editable = this.state.pmoMode || !this.props.logEntry.projectArchived && ( this.props.logEntry.status === "DRAFT" || this.props.logEntry.status === "REJECTED" ) && this.props.timesheet.status !== "SUBMITTED" && moment().subtract(31, 'days').isBefore(moment(this.props.logEntry.date), "DD-MM-YYYY");

        let projectName = this.props.logEntry.projectName ? this.props.logEntry.projectName : "Floating tasks";
        let loggedOnProject = this.state.cumulativeMap[projectName] ? JSON.parse(JSON.stringify(this.state.cumulativeMap[projectName])) : {regularTimeLogged: 0, overtimeLogged: 0};
        let loggedOnTask = this.state.cumulativeMap[projectName] && this.state.cumulativeMap[projectName].tasks[this.props.logEntry.taskName] ? JSON.parse(JSON.stringify(this.state.cumulativeMap[projectName].tasks[this.props.logEntry.taskName])) : {regularTimeLogged: 0, overtimeLogged: 0};

        if (this.state.overtime) {
            loggedOnProject.overtimeLogged += this.state.duration;
            loggedOnTask.overtimeLogged += this.state.duration;
        } else {
            loggedOnProject.regularTimeLogged += this.state.duration;
            loggedOnTask.regularTimeLogged += this.state.duration;
        }

        return (
            <Popover ref="popover" id="editPopoverID" placement={this.state.placement} positionLeft={this.state.positionLeft} positionTop={this.state.positionTop} >
                {/*<form focused={true} onKeyPressCapture={this.handleKeyPress} onKeyUp={this.handleKeyUp.bind(this)}>*/}
                <form onKeyPressCapture={this.handleKeyPress} onKeyUp={this.handleKeyUp.bind(this)}>
                    <div className="head" style={{backgroundColor : backgroundColor, wordWrap: "break-word"}}>
                        <h4>
                            {this.state.selectedTask.projectName ? this.state.selectedTask.projectName : "FLOATING TASK"} &nbsp;&nbsp;
                            <span style={{cursor : "pointer"}} className="md-info" onClick={this.handleCumulativeToggle}/>
                        </h4>
                        <h5>
                            {this.state.selectedTask.name} &nbsp;&nbsp;
                            {
                                editable ?
                                <span style={{"cursor" : "pointer"}} onClick={this.handleEditTaskButton} className="md-mode-edit"/>
                                : null
                            }
                        </h5>
                    </div>
                    <div className="content">
                        <div className="panel-log-date">
                            <div className="row">
                                <div className="col-lg-12">
                                    <span className={calendarClass}><i className="md-today"></i> &nbsp;<span>{this.state.date ? this.state.date.format("ddd YYYY-MM-DD") : null}</span></span>
                                </div>
                            </div>
                        </div>
                        { moment().subtract(31, 'days').isBefore(moment(this.props.logEntry.date), "DD-MM-YYYY") || this.props.pmoMode ? null :
                            <h6>Please contact Tashi Support if you wish to edit this entry.</h6>
                        }
                        {
                            this.state.editTask ?
                            <div className="row">
                                <div className="col-lg-12">
                                    <label>Task:</label>
                                    <AutoTaskInput
                                        autoFocus
                                        filterByDate={this.state.date}
                                        handleSelect={this.handleTaskChange}
                                        hideArchived={!this.props.pmoMode}
                                        hideClosed={!this.props.pmoMode}
                                        onlyTask
                                        ref="taskInput"
                                        tasks={this.state.tasks}
                                        />
                                </div>
                            </div>
                            : null
                        }
                        <div className="row">
                            <div className="col-xs-7">
                                <label>Duration:</label>
                                <input disabled={!editable} type="text" onFocus={this.handleElementFocus} onBlur={this._convertToStandardForm} onChange={this.handleDurationChange} value={this.state.durationString ? this.state.durationString : ""} ref="durationInput" className="form-control"/>
                            </div>
                            <div className="col-sm-5">
                                <div className="checkbox">
                                    <label>
                                        <input disabled={!editable} onFocus={this.handleElementFocus} onBlur={this.handleElementBlur} checked={this.state.overtime} ref="overtimeCheckbox" onChange={this.handleChange} type="checkbox"/> Overtime
                                    </label>
                                </div>
                            </div>
                        </div>

                        <input disabled={!editable} id="slider1" type="range" min="0" max="480" value={this.state.duration ? this.state.duration : 0} step="30" onChange={this.handleSliderChange}/><br/>
                        <div className="row">
                            <div className={this._fieldHasError("startTime") ? "col-xs-7 has-error" : "col-xs-7"}>
                                <label>Start Time:</label>
                                <input disabled={!editable} type="text" ref="startInput" onFocus={this.handleElementFocus} onBlur={this._convertStartTime} onChange={this.handleStartTimeChange} value={this.state.startTime ? this.state.startTime : ""} className="form-control"/>
                            </div>

                        </div>
                        <div className="row">
                            <div className="col-xs-12">
                                <label>Description:</label>
                                <div className="editorPopover">
                                    <SimpleHashtagEditor disabled={!editable} maxLength="1024" value={this.state.description} onChange={this.handleDescriptionChange} />
                                </div>
                            </div>
                        </div>
                        {
                            this.state.showCumulative ?
                            <div>
                                <div className="row">
                                    <div className="col-xs-12">
                                        <label>Logged on project:</label>
                                        <input disabled={true} type="text" className="form-control" value={DurationFormatter.format(loggedOnProject.regularTimeLogged) + " + " + DurationFormatter.format(loggedOnProject.overtimeLogged) + " overtime"}/>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-xs-12">
                                        <label>Logged on task:</label>
                                        <input disabled={true} type="text" className="form-control" value={DurationFormatter.format(loggedOnTask.regularTimeLogged) + " + " + DurationFormatter.format(loggedOnTask.overtimeLogged) + " overtime"}/>
                                    </div>
                                </div>
                            </div>
                            : null
                        }
                        <div className="row">
                            <div className="col-xs-8">
                                <label>Last Modified at:</label>
                                <input disabled={true} defaultValue={lastModifiedAt} type="text" className="form-control"/>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xs-12">
                                <label>Last Modified by:</label>
                                <input disabled={true} defaultValue={this.state.lastModifiedByUser} type="text" className="form-control"/>
                            </div>
                        </div>
                    </div>
                    <div className="footer">
                        {
                            editable
                            ? <button type="button" onFocus={this.handleFooterFocus} onBlur={this.handleFooterBlur} onClick={this.handleSave} style={{backgroundColor : backgroundColor}} className="btn1 btn1-default btn1-primary">
                                Update
                              </button>
                            : null
                        }
                        {
                            editable
                                ? <button type="button" onFocus={this.handleFooterFocus} onBlur={this.handleFooterBlur} onClick={this.handleDelete} className="btn btn-default btn-discrete" data-dismiss="modal">
                                    Delete
                                  </button>
                                : null
                        }
                        <button type="button" onClick={this.handleCancel} onFocus={this.handleFooterFocus} onBlur={this.handleRefocus} className="btn btn-default btn-discrete" data-dismiss="modal">Close</button>
                        <button type="button" onFocus={this.handleRefocus} style={{marginLeft : "0px", "margin" : "0px", "padding" : "0px", "height" : "0px", "width" : "0px", "background": "transparent", "border" : "none"}}/>
                    </div>
                </form>
           </Popover>
        );
    }
}

EditPopover.propTypes = {
    close: PropTypes.func,
    currentUser: PropTypes.object,
    dispatch: PropTypes.func,
    editForUser: PropTypes.object,
    logEntry: PropTypes.object,
    logEntries: PropTypes.array,
    parent: PropTypes.object,
    pmo: PropTypes.object,
    pmoMode: PropTypes.bool,
    positionLeft: PropTypes.number,
    positionTop: PropTypes.number,
    returnKeymaster: PropTypes.func,
    selectedTask: PropTypes.object,
    smartPopoverPlacement: PropTypes.bool,
    tasks: PropTypes.array,
    timesheet: PropTypes.object
};

EditPopover.defaultProps = {
    smartPopoverPlacement: false,
    tasks: [],
    logEntries: []
};

const mapStateToProps = (state) => {
    return {
        currentUser: state.users.currentUser,
        selectedTask: state.tasks.selectedTask
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatch: dispatch
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(EditPopover);



/** WEBPACK FOOTER **
 ** ./src/app/components/EditPopover.js
 **/